import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getFinalDestinationList,
	addNewFinalDestination,
	updateFinalDestination,
	deleteFinalDestination,
	getFinalDestination,
	existsFinalDestination
} from '../finalDestination/thunk';

export const initialState = {
	itemFinalDestinationList: [],
	itemFinalDestinationDetail: null,
	isFinalDestinationLoading: false,
	isFinalDestinationSuccess: false,

	finalDestinationList: [],
	finalDestinationListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	exists: false,
};

const FinalDestinationSlice = createSlice({
	name: 'FinalDestinations',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getFinalDestination.fulfilled, (state, action) => {
			state.isFinalDestinationLoading = false;
			state.isFinalDestinationSuccess = true;
			state.itemFinalDestinationDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getFinalDestination.pending, state => {
			state.isFinalDestinationLoading = true;
			state.isFinalDestinationSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getFinalDestination.rejected, (state, action) => {
			state.isFinalDestinationLoading = false;
			state.isFinalDestinationSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getFinalDestinationList.pending, state => {
			state.isFinalDestinationSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getFinalDestinationList.fulfilled, (state, action) => {
			state.itemFinalDestinationList = action.payload;
			state.finalDestinationList = action.payload;
			state.isLoadingList = false;
			state.isFinalDestinationSuccess = true;

			let finalDestinationListSelect = [];
			action.payload.map(item =>
				finalDestinationListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.finalDestinationListSelect = finalDestinationListSelect;
		});
		builder.addCase(getFinalDestinationList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isFinalDestinationSuccess = true;
		});
		builder.addCase(addNewFinalDestination.fulfilled, (state, action) => {
			state.itemFinalDestinationList.push(action.payload);
			state.finalDestinationList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewFinalDestination.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewFinalDestination.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateFinalDestination.fulfilled, (state, action) => {
			state.itemFinalDestinationList = state.itemFinalDestinationList.map(finalDestination =>
				finalDestination.finalDestinationname === action.payload.old_finalDestination
					? { ...finalDestination, ...action.payload.updated_finalDestination }
					: finalDestination
			);
			state.finalDestinationList = state.finalDestinationList.map(finalDestination =>
				finalDestination._id.toString() === action.payload._id.toString()
					? { ...finalDestination, ...action.payload }
					: finalDestination
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateFinalDestination.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateFinalDestination.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteFinalDestination.fulfilled, (state, action) => {
			state.itemFinalDestinationList = current(state.itemFinalDestinationList).filter(
				item => item._id !== action.payload._id
			);
			state.finalDestinationList = current(state.finalDestinationList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteFinalDestination.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteFinalDestination.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});


		builder.addCase(existsFinalDestination.fulfilled, (state, action) => {
			state.exists = false;
			if (action.payload === true)
				state.exists = true;
		});
		builder.addCase(existsFinalDestination.pending, (state, action) => {
			state.exists = false;
		});
		builder.addCase(existsFinalDestination.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = FinalDestinationSlice.actions;

export default FinalDestinationSlice.reducer;
